/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import configurationApi from '../../../api/configuration.api';
import sanitizeRjsf from '../../../shared/rjsf/sanitizeSchema';
import { lookupI18n } from '../../../shared/utils/objectUtils';
import { configurationPath } from '../../../settings';
import { ConfigResourceProps } from '../../enums/ConfigResourceProps';
import { ResourceType } from '../../enums/ResourceType';
import { createFOAsyncThunk } from '../../helpers/thunk.helpers';

/* Thunks */

/**
 * Fetches the default version from the server
 */
export const fetchDefaultVersion = createFOAsyncThunk('configuration/fetchDefaultVersion', async () => {
  const defaultVersion = await configurationApi.getDefaultVersion();
  return { defaultVersion };
});

/**
 * Fetches a configuration resource from configuration service and applies translation over its content.
 * Arguments to provide:
 *  ConfigResourceProps configResource
 *  String procedure (procedure name)
 *  String version (develop / lithuania / spain / etc)
 */
export const fetchResource = createFOAsyncThunk('configuration/fetchResources', async (arg) => {
  const { configResource, procedure, version } = arg;

  const resourceUrl = buildConfigResourceUrl(configResource, version, procedure);
  const content = await configurationApi.getResource(resourceUrl);
  let translatedContent = lookupI18n(content);

  if (configResource.type === ConfigResourceProps.SUBMISSION_UI_SCHEMA) {
    // TODO fix the rjsf library to not need this
    // TODO: do this fix where the schema is used, not here
    translatedContent = sanitizeRjsf(translatedContent);
  }

  return { name: configResource.name, procedure, value: translatedContent };
});

/* Private helpers */

/**
 * Builds the configuration service URL for a resource based on the version and procedure.
 */
const buildConfigResourceUrl = (configResourceProps, version, procedure) => {
  switch (configResourceProps.type) {
    case ResourceType.COMMON:
      return `${configurationPath}/fo/configuration/${version}/common${configResourceProps.path}`;

    case ResourceType.GENERIC:
      return `${configurationPath}/fo/configuration/${version}${configResourceProps.path}`;

    case ResourceType.PROCEDURE_SPECIFIC:
      return `${configurationPath}/fo/configuration/${version}/${procedure}${configResourceProps.path}`;

    case ResourceType.ROOT:
      return `${configurationPath}/${version}${configResourceProps.path}`;

    default:
      break;
  }

  return configResourceProps.path;
};
